import { IAttributes } from "./IAttributes";
import { IDocument, ISignatures, ISubCategorys } from "./IDocument";
import { ILocationDetails } from "./ILocationDetails";





export class IdoclibFields {

  AttributeID: string;
  AttributeName: string;
  TargetLocID: string;
  selected?: boolean;

}
export class IConsentMasterData_DocLibrary {

  MasterConsentId: number; //Consent form ID
  ConsentName: string; //Consent form Name
  ConsentData: string; //HTML DATA

  // TargetLocationID: number; //id for the ddl check-in,appointment 
  TargetLocationS: string;
  DocDestID: number; //id for the ddl  documentname

  ExpirationDays: number; //expiration days

  DriverSignature: boolean; //yes or No Boolean
  PatientSignature: boolean; //yes or No Boolean
  NurseSignature: boolean; //yes or No Boolean
  ProviderSignature: boolean; //yes or No Boolean

  Isactive: boolean;
  UserBy: string;
  FacilityId: number;
  SelectedSignatureList: string;

  TargetLocationNames?: string;
  SubCategoryName?: string;
  CreatedON?: string;
  ModifiedOn?: string;
  lstlocations? : string[];
  Maptoo? :number=0;
  csvlocationNames:string;
  isIncludeDashboard?: boolean;  
}
export class ICurrentSignature {
  SignatureID: number; //Signature form ID
  SignatureName: string; //Signature form Name

}
export class IConsentNameMasterData_DocLib {

  MasterConsentId: number; //Consent form ID
  ConsentName: string; //Consent form Name
  //  ConsentData: string; //HTML DATA
}

export class IConsentNameMasterData_DocLibAll {

  MasterConsentId: number; //Consent form ID
  ConsentName: string; //Consent form Name
  Isactive: boolean;
  //  ConsentData: string; //HTML DATA
}

export class Idynamic_Intake_Category {
  CategoryID: number;
  Category: string;
  JsonTemplate: string;
  Isactive: boolean;
  showInReports?: boolean;
  DisplayOrder?: number;
  CategoryNotes: string;
  DefaultNotes: string;
  CategoryType: string;
  IsDynamicCategory?: boolean;
  VisitTypeids: string;
  VisitTypes: string;
  VisitTypeCatNames: string;
  VisitTypeCatIds: string;
  CategoryAliasName:string;
  IntakeNote: string; //narayana
  IsCopy: boolean;
}
export class Idynamicfields {
  // itextbox:Itextbox[];
  // idropdown:Idropdown[];
  // icheckbox:Icheckbox[];
  // ilabeltext:Ilabeltext[];
  CategoryID: number;
  Category: string;
  type: string;//
  name: string;//
  label: string;//
  value: string;//
  required: boolean = false;
  multipleSelection: boolean;
  options: Ioptions[];
  posIndex: number;
  JsonTemplate: string;
}
// ReportID,ReportAliasName,SectionId,SectionName 
export class IReportsections {
  reportId: string;
  reportName: string;
  sectionId: string;
  sectionName: string;

}
export class IReportCategorySections {
  CategoryID: string;
  Category: string;
  DisplayOrder?: number;
  IntakeSectionReportID?: number;
  IntakeCategoryReportID?: number;
  CategoryIDs: string;
}
// export class IReportCategorySections{
// sectionID:string;
// CategoryID:string;
// CategoryName:string;
// Isactive:boolean;
// DisplayOrder?:number;
// }

export class Itextbox {
  type: string;//
  name: string;//
  label: string;//
  value: string;//
  required: boolean = false;
  posIndex: number;

}
export class Idropdown {
  type: string;//
  name: string;//
  label: string;//
  value: string;//
  required: boolean = false;
  options: Ioptions[];
  posIndex: number;
}
export class Icheckbox {
  type: string;//
  name: string;//
  label: string;//
  value: string;//
  required: boolean = false;
  multipleSelection: boolean = false;
  options: Ioptions[];
  posIndex: number;
}
interface Ioptions {

  key: string;
  label: string;
  ischecked: boolean;
  // options: [
  //   { key: 'in', label: 'India' },
  //   { key: 'us', label: 'USA' }
  // ]
}
export class Ilabeltext {
  type: string;//'labeltext',
  name: string;//'Headertext',
  value: string;//'Header text',
  label: string;//'First Name',
  posIndex: number;
  required: boolean = false;
}

/*
export class DocumentLibrary_Onload{

  Fields:IdoclibFields[];
  Signatures:ICurrentSignature[];
  MasterConsentNameIDs:IConsentNameMasterData_DocLibAll[];
  TargetLocations: IAttributes[];
  Fieldnames: IAttributes[];
  DocDestinations: ISubCategorys[]; //EMR_DOCUMENT_SUBCATEGORY
  loopSignatures: ISignatures[] ;
  DocDestinationCategory:IDocument[];
  DocDestinationSubCategory:IDocument[];

}
*/



/*
    export interface ITargetLocations {
      TargetId: number;
      TargetName: string;
      }

      export interface IDocDestination {
          DocDestId: number;
          DocDestName: string;
      }

      export interface IFieldsData {
          FieldsId: number;
         FieldsName: string;
      }
    export interface IDocSubCat
    {
      subCategoryId :number;
      docCategoryId :number;
      subCategoryName:string;
      isActive:boolean;
      createdby:string ;

    }
    */